// extracted by mini-css-extract-plugin
module.exports = {"logo":"LogoNav_logo__5WKOm","btn":"LogoNav_btn__ETEaS","create":"LogoNav_create__1Y6fn","btnMenu":"LogoNav_btnMenu__27MtI"};